module.exports = __webpack_public_path__ + "static/teriyakiHero-6639984d39079900d61671256f6de6c8.jpg";